﻿document.addEventListener('DOMContentLoaded', () => {

    const form = document.getElementById('courseSearch');

    if (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const fields = Array.from(form.elements).filter(el => el.name && !el.disabled && (el.tagName === 'SELECT' || (el.tagName === 'INPUT' && el.type === 'search')));

            const params = new URLSearchParams();

            for (const el of fields) {
                if (!el.name || el.disabled) continue;
                const v = el.value.trim();
                if (v !== '') params.append(el.name, v);
                continue;
            }

            const base = form.getAttribute('action');
            const qs = params.toString();
            const url = qs ? `${base}?${qs}` : base;

            window.location.assign(url);
        });
    }
});
